import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

const loader = lazyForPaint(() => {
    return import(/* webpackChunkName: "request-create-form-with-proforma" */ './request-create-form-with-proforma');
});
export const RequestCreateFormWithProforma = withAsync({
    loader,
});
